// TODO: Move this to the @udemy-v2/utils package
export function isObject(value: unknown): value is object {
    return typeof value === 'object' && value !== null && !Array.isArray(value);
}

/**
 * Compares a canonical URL's path against a requested path. Returns the
 * canonical path (relative, hostname stripped, trailing slash normalized)
 * when the paths differ — i.e. when the caller should redirect — or null
 * when they match or no canonical URL is supplied.
 *
 * Trailing-slash differences are not treated as a mismatch.
 */
export function getCanonicalRedirectPath(
    canonicalUrl: string | undefined | null,
    requestedPath: string,
): string | null {
    if (!canonicalUrl) {
        return null;
    }
    const canonicalPath = new URL(canonicalUrl).pathname;
    const withTrailingSlash = (p: string) => (p.endsWith('/') ? p : `${p}/`);
    const normalizedCanonical = withTrailingSlash(canonicalPath);
    const normalizedRequested = withTrailingSlash(requestedPath);
    return normalizedCanonical === normalizedRequested ? null : normalizedCanonical;
}
